import React from "react";

import Paper from "@material-ui/core/Paper";
import Typography from "@material-ui/core/Typography";
import { makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles(theme => ({
  paper: {
    padding: theme.spacing(2),
    margin: "auto",
    marginTop: theme.spacing(1)
  }
}));

export default function InfoWindowSimple({ title, detail }) {
  const classes = useStyles();

  return (
    <Paper className={classes.paper}>
      <Typography variant="subtitle2">{title}</Typography>
      <Typography variant="caption" color="textSecondary">
        {detail}
      </Typography>
    </Paper>
  );
}
